import BoolToggle from '../BoolToggle';
import { UnorderedListOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row } from 'antd';


const TaxFields = (props) => {
  const { onShowRelated } = props;
  return (
    <>
      {onShowRelated && (
        <Row style={{ marginBottom: 12 }}>
          <Col span={24}>
            <Button type="link" icon={<UnorderedListOutlined />} style={{ paddingLeft: 0 }} onClick={onShowRelated}>
              Pokaži vse povezane transakcije
            </Button>
          </Col>
        </Row>
      )}
      <Row gutter={[12, 12]}>
        <Col span={12}>
          <Form.Item
              name="date_to_be_paid"
              label="Realizirano"
              rules={[{ required: true, message: 'Prosim vnesite datum plačila' }]}
              help={<small>Datum realizacije.</small>}
              >
              <DatePicker style={{ width: '100%' }} getPopupContainer={(trigger) => trigger.parentElement} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="is_paid" initialValue={false} label=" " colon={false}>
            <BoolToggle label="Plačano" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="is_issued" initialValue={false} label=" " colon={false}>
            <BoolToggle label="Izdano" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default TaxFields;
